import { useEffect, useState } from 'react';

/**
 * The value, but only after it has stopped changing for `delay` ms.
 * `immediate` skips the wait (e.g. an emptied search box should apply at once).
 */
export function useDebouncedValue(value, delay = 300, immediate = false) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (immediate) {
      setDebounced(value);
      return undefined;
    }
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay, immediate]);

  return debounced;
}
